import React from "react";
import { Helmet } from "react-helmet-async";

const SUPPORTED = ["nl", "en", "de", "fr", "es", "it", "da"];

/**
 * HrefLangAlternates, renders <link rel="alternate" hreflang="..."> for each
 * supported language. Useful for SEO on language-agnostic public pages.
 *
 * Strategy used here: same URL serves all languages via ?lang= param.
 * For the canonical version we emit no ?lang= (defaults to NL).
 *
 * Usage:
 *   <Helmet>
 *     ...other tags...
 *   </Helmet>
 *   <HrefLangAlternates path="/blog/my-post" />
 */
export default function HrefLangAlternates({ path = "" }) {
  if (typeof window === "undefined") return null;
  const base = window.location.origin;
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return (
    <Helmet>
      {/* NL is the default canonical (no prefix) */}
      <link rel="alternate" hrefLang="nl" href={`${base}${cleanPath}`} />
      {SUPPORTED.filter((l) => l !== "nl").map((lng) => (
        <link key={lng} rel="alternate" hrefLang={lng} href={`${base}/${lng}${cleanPath}`} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${base}${cleanPath}`} />
    </Helmet>
  );
}
